module.exports = __webpack_public_path__ + "img/medal1.6988878e.svg";